import React from "react";
import { CTABlock as CTABlockType } from "../../types/optimizely/blocks";
import Button from "../Button/Button";

interface CTABlockProps extends CTABlockType {}

const CTABlock = ({
  heading,
  buttonLink,
  introduction,
  linkText,
}: CTABlockProps) => {
  const handleClick = () => {
    window.open(buttonLink.value, "_self");
  };

  return (
    <div className="flex flex-col text-primary">
      <h3 className="text-mob-article-h3 md:text-article-h3 text-primary font-bold mb-4">
        {heading.value}
      </h3>
      <p className="mb-8">{introduction.value}</p>
      <Button
        className="w-1/2 xl:w-1/3 text-nowrap min-w-40"
        text={linkText.value}
        variant="main"
        onClick={handleClick}
      />
    </div>
  );
};

export default CTABlock;
